export default "__VITE_ASSET__n7QChOC9__"